export function buildWhatsAppUrl(phone: string, message: string) {
  const cleanPhone = phone.replace(/\D/g, "").replace(/^0/, "234");
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
}

export const DEFAULT_WHATSAPP_PHONE = "2348050488734";

export function getWhatsAppLink(message?: string) {
  return buildWhatsAppUrl(
    DEFAULT_WHATSAPP_PHONE,
    message || "Hi Oyinbatfo, I need a quote for..."
  );
}

export async function sendEvolutionMessage(phone: string, text: string) {
  const EVOLUTION_API_URL = import.meta.env.VITE_EVOLUTION_API_URL;
  const EVOLUTION_API_KEY = import.meta.env.VITE_EVOLUTION_API_KEY;
  const EVOLUTION_INSTANCE = import.meta.env.VITE_EVOLUTION_INSTANCE;

  if (!EVOLUTION_API_URL || !EVOLUTION_INSTANCE) {
    console.warn("Evolution API not configured");
    return false;
  }

  try {
    const cleanPhone = phone.replace(/\D/g, "").replace(/^0/, "234");
    const res = await fetch(`${EVOLUTION_API_URL}/message/sendText/${EVOLUTION_INSTANCE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "apikey": EVOLUTION_API_KEY,
      },
      body: JSON.stringify({ number: cleanPhone, text }),
    });
    return res.ok;
  } catch (err) {
    console.error("Evolution API send failed:", err);
    return false;
  }
}
